angular.module('main').directive('btnCopyToQuickbooks', btnCopyToQuickbooks);
btnCopyToQuickbooks.$inject = [
	'integrationsDataService',
	'messageService',
	'$route',
	'$timeout'
];

function btnCopyToQuickbooks(
	integrationsDataService,
	messageService,
	$route,
	$timeout
) {
	return {
		restrict: 'E',
		scope: {
			invoiceId: '<',
			invoiceDisplayId: '<',
			successGetInvoiceInformation: '&',
			reloadPage: '&'
		},
		template: `<button ng-disabled="isBtnDisabled" type="button" class="btn btn-default" ng-click="copyToQuickbooks(invoiceId)">
                            <i class="fi fa fa-files-o"></i>Copy to Quickbooks
                       </button>`,
		replace: true,
		transclude: true,
		link(scope) {
			scope.isBtnDisabled = false;

			scope.copyToQuickbooks = id => {
				scope.isBtnDisabled = true;

				integrationsDataService
					.copyInvoiceToQuickbooks(id)
					.finally(() => (scope.isBtnDisabled = false))
					.subscribe(
						data => successCopyToQuickbooks(data),
						result => errorCopyToQuickbooks(result)
					);
			};

			function successCopyToQuickbooks(data) {
				const result = { data };
				scope.successGetInvoiceInformation({ result });
				messageService.showToaster('s_0', 'qb');
				$timeout($route.reload(), 300);
			}

			function errorCopyToQuickbooks(error) {
				const { data, status } = error;
				const errorMessage = data.errorMessage;
				const errorTitle = error.error.errorTitle;
				let errorCode, errorPlace, value;
				if (errorMessage && status >= 400 && status < 500) {
					switch (errorMessage) {
						case "QuickBooks doesn't allow Inclusive tax for US users":
							errorCode = 'e_3';
							errorPlace = 'qb';
							break;
						case 'Invoice with written off payments is not compatible with QuickBooks':
							errorCode = 'e_7';
							errorPlace = 'qb';
							break;
						case 'Sorry, FR QuickBooks companies are not supported yet':
							errorCode = 'e_8';
							errorPlace = 'qb';
							break;
						case 'Invoice with such ID already exists on QuickBooks':
							errorCode = 'e_1';
							errorPlace = 'qb';
							value = scope.invoiceDisplayId;
							break;
						case 'Invoice with written off payments is not compatible with Xero':
							errorCode = 'e_7';
							errorPlace = 'xero';
							break;
						case 'Invoice has been deleted deleted on QuickBooks':
							errorCode = 'e_17';
							errorPlace = 'qb';
							break;
						case errorMessage.includes(
							'One of the list elements assigned to this transaction has been deleted'
						):
							errorCode = 'e_11';
							errorPlace = 'qb';
							break;
						case errorMessage.includes(
							'Try reselecting the tax rate or reentering the product/service item and saving the form again.'
						):
							errorCode = 'e_19';
							errorPlace = 'qb';
							break;
						case 'Invoice should have the same tax type for all products':
							errorCode = 'e_0';
							errorPlace = 'qb';
							break;
						case "StudioNinja doesn't support transactions with Credit Notes from QuickBooks":
							errorCode = 'e_14';
							errorPlace = 'qb';
							break;

						case 'QB: Impossible to create invoice with Product "Bundle", such item exists on QuickBooks':
							errorCode = 'e_25';
							errorPlace = 'qb';
							break;

						case 'Invoice id length is more than 20':
							errorCode = 'e_27';
							errorPlace = 'qb';
							break;
						case 'Invoice name length is more than 100':
							errorCode = 'e_26';
							errorPlace = 'qb';
							break;
						case errorMessage.includes(
							'QuickBooks: Email Address does not conform to the syntax rules of RFC 822.'
						):
							errorCode = 'e_18';
							errorPlace = 'qb';
							break;
						case 'Invoice description length is more than 4000':
							errorCode = 'e_28';
							errorPlace = 'qb';
							break;
						default:
							if (
								errorTitle &&
								errorTitle !== null &&
								errorMessage &&
								errorMessage !== null
							) {
								messageService.showErrorFromBackend(errorTitle, errorMessage);
							} else {
								messageService.showErrorFromBackend(
									'Slow down, Quickbooks error!'
								);
							}
							return;
					}
				} else {
					errorCode = 'e_0';
					errorPlace = 'general';
				}
				messageService.showToaster(errorCode, errorPlace, value);
			}
		}
	};
}



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnCopyToQuickbooks.js